import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import notification from '../../../services/notification';
import types from '../../types';

function* getGasFeeSettings() {
  try {
    const { status, data } = yield call(api.wallets.getGasFeeSettings);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_GAS_FEE_SETTINGS_SUCCESS, payload: data });
    yield put({ type: types.GET_CURRENT_GAS_PRICE_START });
  } catch (error) {
    yield put({ type: types.GET_GAS_FEE_SETTINGS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* getCurrentGasPrice() {
  try {
    const { status, data } = yield call(api.wallets.getCurrentGasPrice);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_CURRENT_GAS_PRICE_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_CURRENT_GAS_PRICE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateGasFeeSettings({ payload }) {
  try {
    const { status, data } = yield call(api.wallets.updateGasFeeSettings, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_GAS_FEE_SETTINGS_SUCCESS, payload: data });
    yield put({
      type: types.GET_GAS_FEE_SETTINGS_START,
    });
  } catch (error) {
    yield put({ type: types.UPDATE_GAS_FEE_SETTINGS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* gasFeeSettings() {
  yield all([
    takeLatest(types.GET_GAS_FEE_SETTINGS_START, getGasFeeSettings),
    takeLatest(types.UPDATE_GAS_FEE_SETTINGS_START, updateGasFeeSettings),
    takeLatest(types.GET_CURRENT_GAS_PRICE_START, getCurrentGasPrice),
  ]);
}
